module.exports = __webpack_public_path__ + "img/stock1.0038b7cf.png";